module.exports = __webpack_public_path__ + "img/Photo_3___People_&_Pleasures_983_91_155_Pier_&_East_Light.796ae565.jpg";